import { createAction } from "@reduxjs/toolkit";
export const updateTotalExpenses = createAction('updateTotalExpenses');